module.exports = __webpack_public_path__ + "static/media/article1.cbdd9a56.jpg";